import LogoLockup from "./Logo";

const cols = [
    {
        title: "Product",
        links: [
            ["Features", "/product"],
            ["How it works", "/product"],
            ["Privacy", "/privacy"],
        ],
    },
    {
        title: "Company",
        links: [
            ["Manifesto", "/manifesto"],
            ["Contact", "/support#contact"],
            // ["Careers", "/careers"],
            ["Press", "/press"],
        ],
    },
    {
        title: "Legal",
        links: [
            ["Terms", "/terms"],
            ["Privacy Policy", "/privacy"],
            ["Cookies", "/cookies"],
            ["GDPR", "/gdpr"],
        ],
    },
];

export default function Footer() {
    return (
        <footer
            className="relative bg-[var(--paper)] pt-16 pb-10 border-t-2 border-[var(--ink)]"
            data-testid="footer"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                {/* Newspaper masthead */}
                <div className="flex items-center justify-between flex-wrap gap-4 mb-10">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em]">
                        Vol. 01 — The Slow Love Quarterly
                    </div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--hot)]">
                        Winter 2026 · Issue 001
                    </div>
                </div>

                <div className="rule-thick mb-12" />

                <div className="grid lg:grid-cols-[1.5fr_1fr_1fr_1fr] gap-10">
                    <div>
                        <LogoLockup size="text-4xl" />
                        <p className="mt-5 text-[var(--ink-soft)] text-sm max-w-xs leading-relaxed">
                            Because compatibility isn't random. Five matches a
                            week, hand-picked across 12 dimensions of you. The
                            anti-app dating app.
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            {["Instagram", "TikTok", "X", "LinkedIn"].map(
                                (s) => (
                                    <a
                                        key={s}
                                        href="mailto:workwithdilip1@gmail.com"
                                        aria-label={s}
                                        className="font-mono text-[10px] uppercase tracking-[0.2em] border border-[var(--ink)] px-3 py-2 hover:bg-[var(--ink)] hover:text-[var(--paper)] transition"
                                        data-testid={`footer-social-${s.toLowerCase()}`}
                                    >
                                        {s}
                                    </a>
                                ),
                            )}
                        </div>
                    </div>

                    {cols.map((c) => (
                        <div key={c.title}>
                            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--hot)] mb-5">
                                {c.title}
                            </div>
                            <ul className="space-y-3">
                                {c.links.map(([label, href]) => (
                                    <li key={label}>
                                        <a
                                            href={href}
                                            className="font-display text-xl hover:text-[var(--hot)] transition-colors"
                                        >
                                            {label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-16 pt-6 border-t border-[var(--ink)] flex flex-col md:flex-row items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-soft)]">
                    <div>
                        © {new Date().getFullYear()} LÜVYN. All hearts reserved.
                    </div>
                    <div className="font-hand text-xl text-[var(--hot)] normal-case tracking-normal">
                        Made for the slow lovers ♥
                    </div>
                </div>
            </div>
        </footer>
    );
}
